module.exports = __webpack_public_path__ + "img/portrait-097.4be73aea.jpg";